import { ref, Ref } from "vue";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { SyuugyouBasyoOption } from "@/types/SyuugyouBasyo";
import { KanriDaichouListData, ListSearchItem } from "@/types/YuukyuuKanri";

/*
 * 初期処理
 */
export function useInit() {
  const list = ref<KanriDaichouListData[]>()
  // 検索条件formオブジェクト
  const searchForm = ref<ListSearchItem>({ searchDiv: 1 })
  const isError = ref(false)
  const searchOptions = [{ val: 1, code: 1, label: '全ユーザ' }, { val: 2, code: 2, label: '勤務地別' }, { val: 3, code: 3, label: '有休未消化日数の上位' }] 
  const { syuugyouBasyoOptions, getAllSyuugyouBasyoOptions } = useSyuugyouBasyoInit()
  let selectedSyuugyouBasyo: Ref<SyuugyouBasyoOption | null> = ref(null)
  const getSyuugyoBasyoSelect = async () => {
    await getAllSyuugyouBasyoOptions()
    if(syuugyouBasyoOptions.value.length > 0){
      selectedSyuugyouBasyo.value = syuugyouBasyoOptions.value[0]
    }
  }

  return {
    searchForm,
    isError,
    searchOptions,
    getSyuugyoBasyoSelect,
    list,
  }
}
